module.exports = __webpack_public_path__ + "img/model.15830be8.png";